import { Injector, Pipe, PipeTransform } from '@angular/core';
import { LaasSettingService } from 'src/app/core/services/laas-setting.service';

@Pipe({
  name: 'IsPersonalSubscription'
})
export class NotificationPersonalSubscriberPipe implements PipeTransform {

  laasSetting: LaasSettingService;
  constructor(injector: Injector) {
    this.laasSetting = injector.get(LaasSettingService);
  }

  transform(isPersonalEmailSubscriber: number): string {
    if (this.laasSetting.language == "en-us") {
      return isPersonalEmailSubscriber === 1 ? "Yes" : "No"
    } else {
      return isPersonalEmailSubscriber === 1 ? "是" : "否"
    }
  }

}
